<template>
  <ElDropdown class="nav-item navbar-dropdown-menu" trigger="click" data-testid="profile-icon">
    <span class="el-dropdown-link">
      <a class="nav-link p-0 m-1" style="text-decoration: none;">
        <div class="flex items-center">
          <div v-if="user && user.avatar" class="rounded-full overflow-hidden flex items-center justify-center h-7 w-7 md:w-6 sm:w-4 md:h-6 sm:h-4 relative">
            <img :src="user.avatar" class="h-full w-full object-cover" :alt="user.username" />
          </div>
          <div v-else class="rounded-full bg-black flex items-center justify-center h-7 w-7 md:h-6 md:w-6 relative">
            <span v-if="user && user.username" class="text-white font-semibold" style="font-size: 14px; line-height: 20px;">{{ user.username[0].toUpperCase() }}</span>
          </div>
        </div>
      </a>
    </span>
    <ElDropdownMenu slot="dropdown" data-testid="dropdown-menu" class="menudropdown ml-4 mr-2">
      <div class="flex flex-col gap-y-3">
        <ElDropdownItem disabled class="p-0 mx-2">
          <div class="flex items-center justify-start gap-x-2 py-2" style="margin-bottom: 0.625rem">
            <img v-if="user && user.avatar" :src='user.avatar' :alt="user.username" class="rounded-full" style="height:28px; width:28px;"/>
            <div v-else class="rounded-full flex flex-col gap-0 items-center justify-center shrink-0 relative" style="background-color: black; height:32px; width:32px;">
              <div v-if="user?.username" class="bg-[#737475] text-center relative flex items-center justify-center" style="font: var(--labelheavy-large, 500 14px/20px 'Inter', sans-serif); color:white; font-size: 20px;">
                {{ user.username && user.username[0].toUpperCase() }}
              </div>
            </div>
            <div class="flex flex-col items-start justify-center">
              <WcTypography size="xs" weight="600" :title="user.username ?? ''"/>
              <WcTypography size="xs" color="rgba(4,4,16,0.6)" :title="user.email ?? ''"/>
            </div>
          </div>
          <hr v-if="showDivider" />
        </ElDropdownItem>
        <div v-if="!isMobile()" v-permissions="getCareerBrandPagePermissions" class="flex flex-col gap-y-2">
          <WcTypography class="text-left relative mx-2" size="xs" weight="600" color="rgb(1,1,9)" :title="$t('profileDropdown.company')"/>
          <div class="flex flex-col gap-y-1">
            <ElDropdownItem class="mx-1 p-0 rounded" data-testid="company-brand" v-permissions="getCareerBrandPagePermissions">
              <LinkButton :link="{
                name: $t('profileDropdown.companyBrand'),
                to: `/recruiter-settings/brands`,
                active: 'none'
              }"
              />
            </ElDropdownItem>
            <ElDropdownItem class="mx-1 p-0 rounded" data-testid="teamMembers" v-permissions="getTeamsPagePermissions">
              <LinkButton :link="{
                name: $t('profileDropdown.teamMembers'),
                to: `/recruiter-settings/teams`,
                active: 'none'
              }"
              />
            </ElDropdownItem>
          </div>
        </div>
        <div class="flex flex-col gap-y-2" v-if="!isMobile()" v-permissions="getRecruitingPagesPermissions">
          <WcTypography class="text-left relative mx-2" size="xs" weight="600" color="rgb(1,1,9)" :title="$t('profileDropdown.recruiting')"/>
          <div class="flex flex-col gap-y-1">
            <ElDropdownItem v-permissions="stagePipelineArchivalReasonPermissions" class="mx-1 p-0 rounded" data-testid="default-pipeline">
              <LinkButton  :link="{
                  name: $t('profileDropdown.defaultPipeline'),
                  to: `/recruiter-settings/stage-pipeline`,
                  active: 'none'
                }"
              />
            </ElDropdownItem>
            <ElDropdownItem v-permissions="getCompanyEmailTemplateManagePermissions" class="mx-1 p-0 rounded" data-testid="email-templates">
              <LinkButton :link="{
                      name: $t('profileDropdown.emailTemplates'),
                      to: `/recruiter-settings/manage-emails`,
                      active: 'none'
                  }"
              />
            </ElDropdownItem>
          </div>
        </div>
        <div class="flex flex-col gap-y-2" v-if="!isMobile()">
          <WcTypography class="text-left relative mx-2" size="xs" weight="600" :title="$t('profileDropdown.personal')"/>
          <div class="flex flex-col gap-y-1">
            <ElDropdownItem class="mx-1 p-0 rounded" data-testid="calendar">
              <LinkButton
                v-permissions="getCalendarEmailIntegrationsPermissions"
                :link="{
                          name: $t('profileDropdown.calendar'),
                          to: `/recruiter-settings/app-integration`,
                          active: 'none'
                        }"/>
            </ElDropdownItem>
            <ElDropdownItem class="mx-1 p-0 rounded" data-testid="profile">
              <LinkButton  :link="{
                        name: $t('profileDropdown.profile'),
                        to: `/recruiter-settings/profile`,
                        active: 'none'
                      }"/>
            </ElDropdownItem>
          </div>
        </div>
        <div class="flex flex-col gap-y-2" v-if="UserModule().roleAccess !== RolesEnum.COMPANY_EMPLOYEE">
          <WcTypography v-if="!isMobile()" class="text-left relative mx-2" size="xs" weight="600" :title="$t('profileDropdown.resources')"/>
          <div class="flex flex-col gap-y-1">
            <ElDropdownItem @click.native="openHelpCenter" class="mx-1 p-0 rounded" data-testid="help-center">
              <div class="text-decoration-none w-full flex cursor-pointer py-2 px-3 hover:rounded hover:bg-gray-100">
                <WcTypography size="xs" color="#747375" :title="$t('profileDropdown.helpCenter')"/>
              </div>
            </ElDropdownItem>
            <ElDropdownItem class="mx-1 p-0 rounded" v-if="UserModule().roleAccess !== RolesEnum.COMPANY_EMPLOYEE && !isMobile()" @click.native="openExtensionPage" data-testid="chrome-extension" >
              <div class="flex rounded items-center gap-x-1 px-3 py-2">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: #5138EE;">
                  <path d="M17.1625 10.4469L14.5531 7.83749M4.54146 20.4585C5.26341 21.1805 6.42896 21.1805 7.15091 20.4585L18.4585 9.15091C19.1805 8.42896 19.1805 7.26341 18.4585 6.54146C17.7366 5.81951 16.571 5.81951 15.8491 6.54146L4.54146 17.8491C3.81951 18.571 3.81951 19.7366 4.54146 20.4585Z" stroke="#5138EE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.88889 4.40857L10.2222 4L9.83111 5.39286L10.2222 6.78571L8.88889 6.37714L7.55556 6.78571L7.94667 5.39286L7.55556 4L8.88889 4.40857ZM5.33333 9.98L6.66667 9.57143L6.27556 10.9643L6.66667 12.3571L5.33333 11.9486L4 12.3571L4.39111 10.9643L4 9.57143L5.33333 9.98ZM18.6667 14.6229L20 14.2143L19.6089 15.6071L20 17L18.6667 16.5914L17.3333 17L17.7244 15.6071L17.3333 14.2143L18.6667 14.6229Z" stroke="#5138EE" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="text-xs font-medium text-wcButtonColor flex items-center">
                  {{ $t('profileDropdown.downloadChromeExtension') }}
                </div>
              </div>
            </ElDropdownItem>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <ElDropdownItem disabled divided class="dropdown-line"/>
        <ElDropdownItem class="mx-1 p-0 rounded danger" data-testid="logout">
          <LinkButton :link="{
            name: $t('profileDropdown.logout'),
            to: `/logout`,
            class: 'text-wcDarkRed',
            active: 'none'
          }"/>
        </ElDropdownItem>
      </div>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script lang="ts">
import { UserModule } from '@/store/modules/user'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { isMobile } from '@/utils/general'
import WcTypography from '@/components/UILibrary/Typography/WcTypography.vue'
import { PermissionsEnum } from '@/permissions/permissions-enum'
import {
  CAREER_BRAND_PAGE_PERMISSIONS,
  COMPANY_ARCHIVAL_REASONS_MANAGE_PERMISSIONS,
  COMPANY_BOOKING_LINKS_MANAGE, USER_CALENDAR_EMAIL_INTEGRATIONS_MANAGE, COMPANY_EMAIL_TEMPLATES_MANAGE,
  COMPANY_STAGE_PIPELINE_MANAGE_PERMISSIONS,
  COMPANY_TEAM_MEMBERS_MANAGE
} from '@/permissions/permissions-constants'
import { RolesEnum } from '@/views/recruiter/models/roles-model'
import { CompanyModule } from '@/store/modules/company'

@Component({
  name: 'recruiter-nav-dropdown',
  components: { WcTypography },
  computed: {
    RolesEnum() {
      return RolesEnum
    },
    PermissionsEnum() {
      return PermissionsEnum
    }
  },
  methods: {
    CompanyModule() {
      return CompanyModule
    },
    isMobile,
    UserModule() {
      return UserModule
    },
    openExtensionPage() {
      const url = 'https://chrome.google.com/webstore/detail/whitecarrot-extension/kihdfipgbnhlckakgichedgelmkpagck?hl=en'
      window.open(url, '_blank')
    },
    openHelpCenter() {
      const url = 'https://whitecarrot.notion.site/Whitecarrot-io-Help-Centre-9add74c9165a4a2aa6dec8d57cb64f1b'
      window.open(url, '_blank')
    }
  }
})
export default class RecruiterNavbarDropdownMenu extends Vue {
  @Prop() user!: {
    username: string
    email: string
    avatar: string
  }

  get getCareerBrandPagePermissions(): PermissionsEnum[] {
    return CAREER_BRAND_PAGE_PERMISSIONS
  }

  get getTeamsPagePermissions(): PermissionsEnum[] {
    return COMPANY_TEAM_MEMBERS_MANAGE
  }

  get stagePipelineArchivalReasonPermissions(): PermissionsEnum[] {
    return [...COMPANY_STAGE_PIPELINE_MANAGE_PERMISSIONS, ...COMPANY_ARCHIVAL_REASONS_MANAGE_PERMISSIONS]
  }

  get getCompanyBookingLinksManagePermissions(): PermissionsEnum[] {
    return COMPANY_BOOKING_LINKS_MANAGE
  }

  get getCompanyEmailTemplateManagePermissions(): PermissionsEnum[] {
    return COMPANY_EMAIL_TEMPLATES_MANAGE
  }

  get getCalendarEmailIntegrationsPermissions(): PermissionsEnum[] {
    return USER_CALENDAR_EMAIL_INTEGRATIONS_MANAGE
  }

  get getRecruitingPagesPermissions(): PermissionsEnum[] {
    return [
      ...this.stagePipelineArchivalReasonPermissions,
      ...COMPANY_BOOKING_LINKS_MANAGE,
      ...COMPANY_EMAIL_TEMPLATES_MANAGE
    ]
  }

  get showDivider(): boolean {
    return !(UserModule.roleAccess === RolesEnum.COMPANY_EMPLOYEE && isMobile())
  }
}

</script>
<style scoped>
.menudropdown{
  top: 44px !important;
  min-width: 280px !important;
}
</style>
